import { Table } from '@apex/component-library'
import { Box, Text } from '@chakra-ui/react'
import { isEmpty, uniqueId } from 'lodash'
import { DateTime } from 'luxon'
import React from 'react'
import { FaDownload } from 'react-icons/fa'
import { Documents as IDocuments } from '../../../../api/types'
import { ContextualLink } from '../../../../components/ContextualLink'
import { DATE_FORMAT } from '../../../../utils/dateUtil'

export interface DocumentsProps {
  documents: IDocuments
}

const columns = [
  {
    key: 'name',
    label: 'Name',
    recordField: 'name',
    width: 275,
  },
  {
    key: 'date',
    label: 'Date',
    recordField: 'date',
    width: 125,
  },
  {
    key: 'description',
    label: 'Description',
    recordField: 'description',
  },
]

const getTableData = (documents: IDocuments) => {
  return !isEmpty(documents.documents)
    ? documents.documents.map(document => ({
        key: uniqueId(),
        name: (
          <ContextualLink
            href={document.downloadinfo.downloadUrl}
            icon={FaDownload}
            display="flex"
            download
          >
            {document.downloadinfo.filename}
          </ContextualLink>
        ),
        date: DateTime.fromFormat(document.date, 'M/d/yyyy').toFormat(
          DATE_FORMAT
        ),
        description: document.description,
      }))
    : [{ key: 1, name: 'No documents found.', date: '', description: '' }]
}

const Documents = ({ documents }: DocumentsProps) => {
  return (
    <Box>
      <Box bg="gray.600" color="apex.white" p={3}>
        <Text fontWeight="bold">Documents</Text>
      </Box>
      <Box>
        <Table
          columns={columns}
          // @ts-ignore
          data={getTableData(documents)}
          defaultSort={
            !isEmpty(documents.documents)
              ? { field: 'date', ascending: false }
              : undefined
          }
        />
      </Box>
    </Box>
  )
}

export default Documents
